import React, { useState } from 'react'

import Menu from 'components_new/atoms/Menu'
import MenuItem from 'components_new/atoms/Menu/MenuItem'
import Button from 'components_new/atoms/Button'
import Icon from 'components_new/atoms/Icon'
import Text from 'components_new/atoms/Text'
import ListItemText from 'components_new/atoms/List/ListItemText'

import Styles from './styles.module.css'

// Override antd css.
import './styles.css'

const DropdownButton = (props) => {
  const {
    children,
    transparent,
    items = [],
    noChevron,
    header,
    subHeader,
    icon,
    iconClassName,
    disabled
  } = props
  const [anchorEl, setAnchorEl] = useState(null)
  const open = Boolean(anchorEl)

  const handleClose = () => {
    setAnchorEl(null)
  }

  return (
    <>
      {icon ? (
        <div
          className={Styles['icon-container']}
          onClick={(event) => {
            setAnchorEl(event.currentTarget)
          }}
        >
          <Icon name={icon} className={iconClassName} />
        </div>
      ) : (
        <Button
          disabled={disabled}
          endIcon={noChevron ? null : <Icon name="ExpandMore" />}
          variant={transparent ? 'text' : 'contained'}
          onClick={(event) => {
            setAnchorEl(event.currentTarget)
          }}
        >
          {children}
        </Button>
      )}
      {/*-- menu --*/}
      <Menu
        anchorEl={anchorEl}
        onClose={handleClose}
        open={open}
        PaperProps={{ sx: { minWidth: 320 } }}
      >
        <Text>{header}</Text>
        <Text>{subHeader}</Text>
        {items.map((item) => {
          return (
            <>
              <Text>{item.header}</Text>
              {item.items.map((child, index) => (
                <MenuItem
                  key={`${item.key}-${index}`}
                  disabled={child.disabled}
                  onClick={() => {
                    child.onClick()
                    handleClose()
                  }}
                >
                  <ListItemText
                    secondaryTypographyProps={{
                      color: 'text.secondary',
                      fontWeight: 'medium',
                      variant: 'caption'
                    }}
                  >
                    {child.label}
                    {child.subLabel}
                  </ListItemText>
                </MenuItem>
              ))}
            </>
          )
        })}
      </Menu>
    </>
  )
}

export default DropdownButton
